export default {
  data() {
    return {
      windowWidth: 0,
      deviceType: '',
    };
  },
  computed: {
    isPhone() {
      return this.windowWidth < 640;
    },
    isTablet() {
      return this.windowWidth >= 640 && this.windowWidth < 1024;
    },
    isDesktop() {
      return this.windowWidth >= 1024;
    },
    isAndroid() {
      return /Android/i.test(navigator.userAgent);
    },
    isIOS() {
      return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    },
    isNeither() {
      return !this.isAndroid && !this.isIOS;
    },
  },
  mounted() {
    this.updateWindowWidth();
    window.addEventListener('resize', this.updateWindowWidth);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateWindowWidth);
  },
  methods: {
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
      this.setDeviceType();
    },
    setDeviceType() {
      if (this.isPhone) {
        this.deviceType = 'phone';
      } else if (this.isTablet) {
        this.deviceType = 'tablet';
      } else {
        this.deviceType = 'desktop';
      }
    },
  },
};
